import DefaultMapper, { toPagingAndSorting } from 'cw-core-admin-ui/src/dataProvider/DefaultMapper';
import { stringify } from 'query-string';
import { API_BASE_PATH_DEMOWALLET_ADMIN } from '../../constants';

class InvoiceVoucherMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/tx/vouchers';
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.method = 'POST';
		switch (params.method) {
			case 'activate':
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}:activate`;
				break;
			case 'cancel':
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}:cancel`;
				break;
			case 'lock':
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}:lock`;
				options.body = JSON.stringify({
					description: params.data.description,
				});
				break;
			case 'unlock':
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}:unlock`;
				break;
			default:
				// Case: CreateInvoiceVoucher
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}`;
				options.body = JSON.stringify({
					activate: params.data.activate,
					systemAccountId: params.data.systemAccountId,
					type: params.data.type,
					amount: params.data.amount,
					description: params.data.description,
					emailAddress: params.data.emailAddress,
					marketingAction: params.data.marketingAction,
				});
				break;
		}
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...params.filter,
			...toPagingAndSorting(params),
		};
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}?${stringify(query)}`;
	}

	finishGetList({ result }) {
		return {
			total: result.meta.totalItems,
			data: result.data.map((value) => value.voucherInfo),
		};
	}

	prepareGetOne({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}`;
	}

	mapResult({ type, resource, params, options, mappedResource, result }) {
		return result.data.voucherInfo;
	}

	finishGetOne({ type, resource, params, options, mappedResource, result }) {
		return {
			...result,
			data: {
				...result.data.voucherInfo,
				id: result.data.voucherInfo.id,
			},
		};
	}
}

export default InvoiceVoucherMapper;
